var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('main',{staticClass:"app-main"},[(_vm.todoTasks.length || _vm.inProgressTasks.length || _vm.completedTasks.length)?_c('TrelloDashboard',_vm._l((_vm.taskColumns),function(ref,index){
var id = ref.id;
var color = ref.color;
var text = ref.text;
return _c('TrelloColumn',{key:index,attrs:{"id":id,"color":color,"text":text,"tasks":_vm.getTasks(id)}})}),1):_c('div',[_c('span',[_vm._v("Loading...")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }